import { modalidades, resultado_modalidades } from "../../../../utils/jecos";
import styles from "../../../../styles/module/jecos/jecos.module.css";

export default function Jecos() {
  return (
    <div className={styles.container}>
      <main className={styles.main}>
        <section className={styles.heroSection}>
          <div className={styles.heroContent}>
            <div className={styles.logoPlaceholder}>
              <img
                src="/imagens/jecos/logo_jecos.png"
                alt="Logo JECOS"
                className={styles.logoImage}
              />
            </div>
            <div className={styles.mainTitleContainer}>
              <h1 className={styles.mainTitle}>
                Jogos Escolares{" "}
                <span className={styles.highlight}>Codoenses</span>
              </h1>

              <p className={styles.subtitle}>
                Unindo esporte, educação e cidadania em Codó - Maranhão
              </p>
            </div>
          </div>

          <div className={styles.infoCards}>
            <div className={styles.infoCard}>
              <div className={styles.infoIcon}>📅</div>
              <div>
                <div className={styles.infoLabel}>Período</div>
                <div className={styles.infoValue}>Mês de Junho - 2025</div>
              </div>
            </div>
            <div className={styles.infoCard}>
              <div className={styles.infoIcon}>🏫</div>
              <div>
                <div className={styles.infoLabel}>Participantes</div>
                <div className={styles.infoValue}>Escolas Municipais</div>
              </div>
            </div>
            <div className={styles.infoCard}>
              <div className={styles.infoIcon}>🏆</div>
              <div>
                <div className={styles.infoLabel}>Objetivo</div>
                <div className={styles.infoValue}>Integração Escolar</div>
              </div>
            </div>
          </div>
        </section>

        <section className={styles.heroImageContent}>
          <div className={styles.heroImage}>
            <img
              src="/imagens/jecos/banner_jecos.png"
              alt="Jogos Escolares de Codó-MA"
              className={styles.image}
            />
          </div>
        </section>

        <section className={styles.scheduleSection}>
          <h2 className={styles.sectionTitle}>
            <span className={styles.titleIcon}>📋</span>
            Cronograma das Modalidades
          </h2>

          <div className={styles.tableContainer}>
            <table className={styles.table}>
              <thead className={styles.tableHeader}>
                <tr>
                  <th className={styles.th}>Modalidade</th>
                  <th className={styles.th}>Realização</th>
                  <th className={styles.th}>Local</th>
                  <th className={styles.th}>Boletim</th>
                </tr>
              </thead>
              <tbody className={styles.tableBody}>
                {modalidades.map((item, index) => (
                  <tr key={index} className={styles.tr}>
                    <td className={styles.td}>
                      <span className={styles.modalidade}>
                        {item.modalidade}
                      </span>
                    </td>
                    <td className={styles.td}>
                      <span className={styles.data}>{item.realizacao}</span>
                    </td>
                    <td className={styles.td}>
                      <span className={styles.local}>{item.local}</span>
                    </td>
                    <td className={styles.td}>
                      <span className={styles.local}>
                        <a
                          className={styles.clickable}
                          href={`${item.link}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Clique aqui
                        </a>
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <section
          className={styles.scheduleSection}
          style={{ marginTop: "100px" }}
        >
          <h2 className={styles.sectionTitle}>
            <span className={styles.titleIcon}>📋</span>
            Resultados Finais
          </h2>

          <div className={styles.tableContainer}>
            <table className={styles.table}>
              <thead
                className={styles.tableHeader}
                style={{ background: "#ff0707" }}
              >
                <tr>
                  <th className={styles.th}>Modalidade</th>

                  <th className={styles.th}>Boletim Final</th>
                </tr>
              </thead>
              <tbody className={styles.tableBody}>
                {resultado_modalidades.map((item, index) => (
                  <tr key={index} className={styles.tr}>
                    <td className={styles.td}>
                      <span className={styles.modalidade}>
                        {item.modalidade}
                      </span>
                    </td>

                    <td className={styles.td}>
                      <span className={styles.local}>
                        <a
                          className={styles.clickable}
                          href={`${item.link}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {item.link !== "#" ? "Clique aqui" : "Em breve"}
                        </a>
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <section className={styles.statsSection}>
          <div className={styles.statsGrid}>
            <div className={styles.statCard}>
              <div className={styles.statIcon}>🏃‍♂️</div>
              <div className={styles.statNumber}>13</div>
              <div className={styles.statLabel}>Modalidades</div>
            </div>
            <div className={styles.statCard}>
              <div className={styles.statIcon}>📍</div>
              <div className={styles.statNumber}>8</div>
              <div className={styles.statLabel}>Locais de Competição</div>
            </div>
            <div className={styles.statCard}>
              <div className={styles.statIcon}>🗓️</div>
              <div className={styles.statNumber}>19</div>
              <div className={styles.statLabel}>Dias de Competição</div>
            </div>
          </div>
        </section>

        <section className={styles.heroImageContent}>
          <div className={styles.antiRacismBanner}>
            <img
              src="/imagens/jecos/banner_racismo.png"
              alt="Banner contra Racismo"
              className={styles.image}
            />
          </div>
        </section>
      </main>
    </div>
  );
}
